import React from 'react';
import { SingleNumberCard } from '../../shared/components/numberInput/numberCards/singleNumberCard';
import { BoxStyled } from '../patientInformation/style';

export const BottleView = ({
  setBottleInput,
  value,
  typeofcategory
}: {
  setBottleInput: (val: number) => void;
  value: number;
  typeofcategory?: string;
}) => {
  return (
    <BoxStyled>
      <SingleNumberCard
        width={'50%'}
        title={`NUMBER OF ${typeofcategory?.toUpperCase()}S`}
        marginVal={'0.625rem'}
        subHead={''}
        value={value}
        setValue={setBottleInput}
      />
    </BoxStyled>
  );
};
